// 일반 전화번호 포맷팅 함수
export const formatTel = (value: string) => {
  const numbers = value.replace(/[^\d]/g, '');

  const limitedNumbers = numbers.slice(0, 11);

  if (limitedNumbers.startsWith('02')) {
    // 서울 (02-0000-0000 또는 02-000-0000)
    if (limitedNumbers.length <= 2) {
      return limitedNumbers;
    } else if (limitedNumbers.length <= 5) {
      return `${limitedNumbers.slice(0, 2)}-${limitedNumbers.slice(2)}`;
    } else if (limitedNumbers.length <= 9) {
      return `${limitedNumbers.slice(0, 2)}-${limitedNumbers.slice(2, 5)}-${limitedNumbers.slice(5)}`;
    } else {
      return `${limitedNumbers.slice(0, 2)}-${limitedNumbers.slice(2, 6)}-${limitedNumbers.slice(6)}`;
    }
  } else {
    // 그외 지역 (031-000-0000)
    if (limitedNumbers.length <= 3) {
      return limitedNumbers;
    } else if (limitedNumbers.length <= 6) {
      return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
    } else {
      return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3, 6)}-${limitedNumbers.slice(6)}`;
    }
  }
};

// 휴대폰 번호 실시간 입력 포맷팅 함수 (UI용)
export const formatMobilePhoneInput = (value: string) => {
  const numbers = value.replace(/[^\d]/g, '');

  const limitedNumbers = numbers.slice(0, 11);

  if (limitedNumbers.length <= 3) {
    return limitedNumbers;
  } else if (limitedNumbers.length <= 7) {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3)}`;
  } else {
    return `${limitedNumbers.slice(0, 3)}-${limitedNumbers.slice(3, 7)}-${limitedNumbers.slice(7)}`;
  }
};
